import { useEffect, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";



type CopyButtonProps = { value: string; };

/**
 * Copies a result only on user interaction and reports clipboard availability.
 * @param props Component properties.
 * @param props.value Result to copy; an empty value disables the button.
 */
export const CopyButton = (props: CopyButtonProps) => {
	const [ status, setStatus ] = useState("");

	useEffect(() => { setStatus(""); }, [ props.value ]);
	useEffect(() => {
		if(!status) return;
		const timer = window.setTimeout(() => setStatus(""), 3000);
		return () => window.clearTimeout(timer);
	}, [ status ]);

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(props.value);
			setStatus("Copied");
		} catch {
			setStatus("Copy unavailable. Select and copy the text manually.");
		}
	};

	return (
		<Stack direction="row" spacing={ 2 } alignItems="center">
			<Button variant="outlined" disabled={ !props.value } onClick={ copy }>Copy output</Button>
			<Typography role="status">{ status }</Typography>
		</Stack>
	);
};
